import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import {
  MaintenancePriority,
  MaintenanceRequest,
  MaintenanceStats,
  MaintenanceStatus,
  MaintenanceTabType,
} from '@/models/features'

export interface GetMaintenanceRequestsRequest {
  buildingId?: number
  search?: string
  type?: MaintenanceTabType
  status?: MaintenanceStatus[]
  priority?: MaintenancePriority[]
  yardiPropertyId?: string[]
  clientId?: number[]
  unitId?: number
  dateFrom?: number
  dateTo?: number
  updatedAtSort?: 'ASC' | 'DESC'
  limit?: number
  skip?: number
}

export type GetMaintenanceRequestsResponse = MaintenanceStats & {
  maintenanceRequests: MaintenanceRequest[]
}

export const GET_MAINTENANCE_REQUESTS_BASE_QUERY_KEY = 'useGetMaintenanceRequests'

export const getMaintenanceRequestsQueryKey = (data: GetMaintenanceRequestsRequest) => [
  GET_MAINTENANCE_REQUESTS_BASE_QUERY_KEY,
  data,
]

// Note: a POST despite being a read - matches the legacy `/v2/maintenance/filter` endpoint
// (body-based filtering, not query params).
export const getMaintenanceRequests = async (
  data: GetMaintenanceRequestsRequest,
  signal?: AbortSignal,
) => {
  const response = await authAPI.post<GetMaintenanceRequestsResponse>(
    '/v2/maintenance/filter',
    data,
    { signal },
  )
  return response.data
}

export const useGetMaintenanceRequests = (
  data: GetMaintenanceRequestsRequest,
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    enabled: !!data.buildingId && (options.enabled ?? true),
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getMaintenanceRequests(data, signal),
    queryKey: getMaintenanceRequestsQueryKey(data),
  })
}
